import React from 'react';
import { Typography, Box, Container, Paper } from '@mui/material';
import SEO from '../components/common/SEO';
import CallToAction from '../components/home/CallToAction';

 
const About: React.FC = () => {

  return (
    <>
      <SEO 
        title="About CEO Keynotes - Premier Speaker Booking Agency"
        description="Learn about CEO Keynotes and our mission to connect organizations with world-class speakers who inspire and educate audiences worldwide. Discover our expertise in speaker booking and event success."
        keywords="about CEO Keynotes, speaker booking agency, keynote speakers, corporate events, leadership speakers, event planning, speaker bureau, motivational speakers"
        url="/about"
      />
      
      <Box sx={{ 
        bgcolor: 'black', 
        minHeight: '100vh',
        color: 'white'
      }}>
        <Container maxWidth="lg" sx={{ py: 4, pt: 16 }}>
          {/* Header */}
          <Box sx={{ mb: 8, textAlign: 'center' }}>
            <Typography 
              variant="h2" 
              component="h1" 
              gutterBottom
              sx={{
                fontFamily: '"Manrope", sans-serif',
                fontWeight: 700,
                mb: 3,
                color: 'white',
                fontSize: {
                  xs: '1.8rem',  
                  sm: '2.0rem',    
                  md: '2.4rem'   
                }
              }}
            >
              About Us
            </Typography>
            <Typography 
              variant="h5" 
              sx={{
                fontFamily: '"Newsreader", serif',
                maxWidth: '800px',
                mx: 'auto',
                color: 'rgba(255, 255, 255, 0.7)',
                lineHeight: 1.6,
                fontSize: {
                  xs: '1.0rem',  
                  sm: '1.1rem',    
                  md: '1.25rem'  
                }
              }}
            >
              CEO Keynotes has decades of experience connecting organizations with world-class speakers who inspire audiences worldwide.
            </Typography>
          </Box>
          <Box sx={{ mb: 8, textAlign: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on mobile, horizontal on larger screens
                justifyContent: 'center',
                alignItems: 'center',
                gap: { xs: 2, sm: 2 }, // Responsive gap between images
                maxWidth: { xs: '400px', sm: '600px' }, // Smaller max width on mobile for single column
                mx: 'auto', // Center the flex container
                mb: 2, // Margin below images, before the caption
              }}
            >
              <img
                src="/ohanian.jpg"
                alt="Alexis Ohanian speaking"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '400px',
                  objectFit: 'cover',
                  borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(255, 255, 255, 0.1)',
                }}
              />
              <img
                src="/robbins.jpg"
                alt="Mel Robbins speaking"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '400px',
                  objectFit: 'cover',
                  borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(255, 255, 255, 0.1)',
                }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{
                mt: 2, // Margin top for spacing from the image
                color: 'rgba(255, 255, 255, 0.6)', // Slightly dimmer color for caption
                fontFamily: '"Newsreader", serif', // Consistent with other descriptive text
                fontSize: {
                  xs: '0.85rem',  
                  sm: '0.9rem',    
                  md: '1.0rem'  
                }
              }}
            >
              Proud to represent Alexis Ohanian (Reddit) and Mel Robbins (143 Studios).
            </Typography>
          </Box>

            {/* Access to Any Speaker */}
            <Paper elevation={2} sx={{ 
            p: { xs: 4, md: 8 }, 
            mb: 8,
            bgcolor: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <Typography 
              variant="h4" 
              component="h2" 
              gutterBottom
              sx={{
                fontFamily: '"Manrope", sans-serif',
                fontWeight: 600,
                mb: 3,
                color: 'white',
                fontSize: {
                  xs: '1.5rem',
                  sm: '1.75rem',
                  md: '2rem'
                }
              }}
            >
              Access to Virtually Any Business Speaker
            </Typography>
            <Typography 
              variant="body1"
              sx={{
                fontFamily: '"Newsreader", serif',
                maxWidth: '800px',
                mx: 'auto',
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.8,
                mb: 4,
                fontSize: {
                  xs: '1.0rem',
                  sm: '1.1rem',
                  md: '1.2rem'
                }
              }}
            >
              With three decades of industry experience, our extensive network and relationships give us access to virtually any business speaker on the planet. Whether they&apos;re featured on our website or not, if there&apos;s a speaker you want for your event, we can book them. <a href="/contact" style={{ color: '#90cdf4', textDecoration: 'underline', fontWeight: 500 }}>Contact us</a>.

            </Typography>
            
            
          </Paper>


          {/* What We Offer */}
          <Box sx={{ mb: 8 }}>
             <Typography 
              variant="h4" 
              component="h2" 
              gutterBottom
              sx={{
                fontFamily: '"Manrope", sans-serif',
                fontWeight: 600,
                mb: 2,
                color: 'white',
                textAlign: 'center'
              }}
            >
              What We Offer
            </Typography>

            <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              mb: 4,
              mt: 4,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <img
              src="/speaker-alt.jpg"
              alt="Alternative Speaker"
              style={{
                maxWidth: '120%',
                height: 'auto',
                maxHeight: '500px',
                objectFit: 'fill',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(255, 255, 255, 0.1)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(to right, black 0%, transparent 50%, transparent 50%, black 100%)',
                pointerEvents: 'none',
              }}
            />
          </Box>

            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
              gap: 4,
            }}>
              {/* Service 1 */}
              <Paper elevation={1} sx={{ 
                p: 4,
                bgcolor: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px'
              }}>
                <Typography 
                  variant="h6" 
                  gutterBottom
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    fontWeight: 600,
                    color: 'white',
                    mb: 2
                  }}
                >
                  Corporate Events
                </Typography>
                <Typography 
                  variant="body1"
                  sx={{
                    fontFamily: '"Newsreader", serif',
                    color: 'rgba(255, 255, 255, 0.8)',
                    lineHeight: 1.6,
                  }}
                >
                  From annual conferences to team meetings, our speakers deliver keynotes that align with your company's goals and values.
                </Typography>
              </Paper>

              {/* Service 2 */}
              <Paper elevation={1} sx={{ 
                p: 4,
                bgcolor: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px'
              }}>
                <Typography 
                  variant="h6" 
                  gutterBottom
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    fontWeight: 600,
                    color: 'white',
                    mb: 2
                  }}
                >
                  Leadership Development
                </Typography>
                <Typography 
                  variant="body1"
                  sx={{
                    fontFamily: '"Newsreader", serif',
                    color: 'rgba(255, 255, 255, 0.8)',
                    lineHeight: 1.6
                  }}
                >
                  Inspire your leadership team with insights from CEOs and executives who have built successful organizations.
                </Typography>
              </Paper>

              {/* Service 3 */}
              <Paper elevation={1} sx={{ 
                p: 4,
                bgcolor: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px'
              }}>
                <Typography 
                  variant="h6" 
                  gutterBottom
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    fontWeight: 600,
                    color: 'white',
                    mb: 2
                  }}
                >
                  Industry Conferences
                </Typography>
                <Typography 
                  variant="body1"
                  sx={{
                    fontFamily: '"Newsreader", serif',
                    color: 'rgba(255, 255, 255, 0.8)',
                    lineHeight: 1.6
                  }}
                >
                  Connect your audience with thought leaders who are shaping the future of your industry.
                </Typography>
              </Paper>

              {/* Service 4 */}
              <Paper elevation={1} sx={{ 
                p: 4,
                bgcolor: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px'
              }}>
                <Typography 
                  variant="h6" 
                  gutterBottom
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    fontWeight: 600,
                    color: 'white',
                    mb: 2
                  }}
                >
                  Custom Programs
                </Typography>
                <Typography 
                  variant="body1"
                  sx={{
                    fontFamily: '"Newsreader", serif',
                    color: 'rgba(255, 255, 255, 0.8)',
                    lineHeight: 1.6
                  }}
                >
                  Work with us to create tailored speaking experiences that address your specific challenges and objectives.
                </Typography>
              </Paper>
            </Box>
          </Box>

        
          {/* How It Works */}
          <Box sx={{ mb: 8 }}>
            <Typography 
              variant="h4" 
              component="h2" 
              gutterBottom
              sx={{
                fontFamily: '"Manrope", sans-serif',
                fontWeight: 600,
                mb: 2,
                color: 'white',
                textAlign: 'center'
              }}
            >
              How the Booking Process Works
            </Typography>
            <Typography 
              variant="body1"
              sx={{
                fontFamily: '"Newsreader", serif',
                maxWidth: '800px',
                mx: 'auto',
                color: 'rgba(255, 255, 255, 0.7)',
                lineHeight: 1.6,
                textAlign: 'center',
                mb: 6,
                fontSize: {
                  xs: '0.95rem',
                  sm: '1.0rem',
                  md: '1.1rem'
                }
              }}
            >
              We&apos;ve streamlined our process to make booking a world-class speaker simple and stress-free.
            </Typography>

            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
              gap: 4,
              position: 'relative'
            }}>
              {[
                { 
                  step: '01', 
                  title: 'Tell Us Your Needs', 
                  desc: 'Share your event details, audience, and goals with our team.' 
                },
                { 
                  step: '02', 
                  title: 'Get Recommendations', 
                  desc: "We'll match you with speakers perfectly suited to your event." 
                },
                { 
                  step: '03', 
                  title: 'Review & Select', 
                  desc: 'Review speaker profiles, videos, and testimonials to make your choice.' 
                },
                { 
                  step: '04', 
                  title: 'We Handle Details', 
                  desc: 'From contracts to logistics, we manage everything for a seamless event.' 
                }
              ].map((item, index) => (
                <Box 
                  key={index}
                  sx={{ 
                    textAlign: 'center',
                    position: 'relative'
                  }}
                >
                  <Typography 
                    variant="h2"
                    sx={{
                      fontFamily: '"Manrope", sans-serif',
                      fontWeight: 800,
                      color: 'rgba(255, 255, 255, 0.1)',
                      fontSize: {
                        xs: '3rem',
                        md: '4rem'
                      },
                      mb: 2
                    }}
                  >
                    {item.step}
                  </Typography>
                  <Typography 
                    variant="h6"
                    sx={{
                      fontFamily: '"Manrope", sans-serif',
                      fontWeight: 600,
                      color: 'white',
                      mb: 2,
                      fontSize: {
                        xs: '1.0rem',
                        md: '1.1rem'
                      }
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography 
                    variant="body2"
                    sx={{
                      fontFamily: '"Newsreader", serif',
                      color: 'rgba(255, 255, 255, 0.7)',
                      lineHeight: 1.6,
                      fontSize: {
                        xs: '0.85rem',
                        md: '0.95rem'
                      }
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Call to Action */}
          <CallToAction title={"Ready to Transform Your Event?"} />
        </Container>
      </Box>
    </>
  );
};

export default About; 